import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './RadioInput.scss';

class RadioInput extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
    /** function to call when value changed. */
    onChange: PropTypes.func,
    /** value of the input. */
    value: PropTypes.any,
    /** default value of the input. */
    defaultValue: PropTypes.any,
    /** array of radio options. */
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    className: '',
    onChange: () => {},
    options: [],
  };

  hasValue = value => value !== null && value !== undefined;

  render() {
    const { className, onChange, options, value, defaultValue } = this.props;

    const selected = this.hasValue(value) ? value : defaultValue;

    return (
      <div
        className={classnames('common-input', 'common-radio-input', className)}
      >
        {options.map((opt, i) => (
          <div
            key={i}
            className={classnames('common-radio-input__option', {
              'common-radio-input__option--active': opt.value === selected,
            })}
            value={opt.value}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
            {opt.value === selected && <i className="fa fa-check" />}
          </div>
        ))}
      </div>
    );
  }
}

export default RadioInput;



// WEBPACK FOOTER //
// ./src/components/common/radio-input/RadioInput.js